import { render } from "./QuickpayPDFViewer.vue?vue&type=template&id=a6f6ebce&scoped=true"
import script from "./QuickpayPDFViewer.vue?vue&type=script&lang=js"
export * from "./QuickpayPDFViewer.vue?vue&type=script&lang=js"

import "./QuickpayPDFViewer.vue?vue&type=style&index=0&id=a6f6ebce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f6ebce"]])

export default __exports__